module.exports = __webpack_public_path__ + "media/images/backgrounds/glin-symbol-secondary-529e5bedddcabc6e4472f360847a17cc.png";